import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=ee51d692"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "./Orders.vue?vue&type=style&index=0&id=ee51d692&prod&lang=scss"
import style1 from "./Orders.vue?vue&type=style&index=1&id=ee51d692&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports